import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import React from 'react'

interface CollapseProps {
  dir?: 'col' | 'row'
  id?: string
  open?: boolean
}

function Collapse({
  children,
  dir = 'col',
  id,
  open = false,
}: PropsWithChildren<CollapseProps>): JSX.Element | null {
  return (
    <div
      className={clsx(
        open
          ? ['flex overflow-hidden', dir === 'col' ? 'flex-col' : 'flex-row']
          : 'hidden',
      )}
      id={id}
    >
      {children}
    </div>
  )
}

export default Collapse
